// const ONE_HUNDRED_THOUSAND = 100000;
// const TEN_THOUSAND = 10000;

const reducer = (state, { type, payload }) => {
	//console.log('reducer:', type, payload);
	let profile, office, address0, addresses, closedTasks;
	switch (type) {
		case "LOAD_ACCOUNT":
			return {
				...state,
				loading: false,
				focusInput: undefined,
				message: payload.message,
				requireCheck: null,
				user: payload.user,
			}

		case "LOAD_TASKS":
			return {
				...state,
				loading: false,
				message: payload.message,
				requireCheck: null,
				tasks: payload.tasks,
				first: payload.first,
				moreTaskAvailable: payload.tasks?.length > 0,
			}

		case "LOAD_MORE_CLOSED_TASKS":
			closedTasks = state.closedTasks || [];
			return {
				...state,
				loading: false,
				message: payload.message,
				requireCheck: null,
				first: payload.first,
				closedTasks: [].concat(closedTasks).concat(payload.tasks.filter(c => !closedTasks.some(st => st._id === c._id))),
				moreClosedAvailable: payload.moreClosedAvailable,
			}

		case "SUCCESS":
			return {
				...state,
				message: payload,
				loading: false,
				requireCheck: null,
			}
		case "SET_ACCOUNT_PROFILE_PART":
			profile = state.user?.profile || {};
			return {
				...state,
				user: {
					...state.user,
					profile: {
						...profile,
						...payload
					},
				},
			}
		case "SET_ACCOUNT_PROFILE_OFFICE_PART":
			profile = state.user?.profile || {};
			office = state.user.profile?.office || {};
			return {
				...state,
				user: {
					...state.user,
					profile: {
						...profile,
						office: {
							...office,
							...payload
						},
					},
				}
			}

		case "SET_ACCOUNT_PROFILE_OFFICE_ADDRESS_UNIT":
			profile = state.user?.profile || {};
			office = state.user.profile?.office || {};
			addresses = (payload.isEditCustomerAddress ? state.user.profile?.addresses : state.user.profile?.office?.addresses || []);
			address0 = addresses[0] || {};
			address0 = {
				stateID: 1,
				cityID: 1,
				...address0,
			};

			addresses = payload.unit?.length === 0 ? [address0] : payload.unit?.map((c, idx) => ({
				...address0,
				_id: addresses[idx]?._id || undefined,
				unit: c,
			}));

			return {
				...state,
				user: {
					...state.user,
					profile: {
						...profile,
						...(payload.isEditCustomerAddress ? { addresses } : {}),
						office: {
							...office,
							addresses,
						}
					},
				},
			}

		case "SET_ACCOUNT_PROFILE_OFFICE_ADDRESS":
			profile = state.user?.profile || {};
			office = state.user.profile?.office || {};
			addresses = (payload.isEditCustomerAddress ? state.user.profile?.addresses : state.user.profile?.office?.addresses || []);
			address0 = addresses[0] || {};
			address0 = {
				...address0,
				...payload,
			};

			addresses = [address0].slice(state.user.profile?.office?.addresses, 1).map((c, idx) => ({
				...address0,
				_id: addresses[idx]?._id || undefined,
				unit: c.unit,
			}));

			return {
				...state,
				user: {
					...state.user,
					profile: {
						...profile,
						...(payload.isEditCustomerAddress ? { addresses } : {}),
						office: {
							...office,
							addresses,
						}
					},
				},
			}
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}
		case "CLEAR_STATE_DATA":
			return {
				activeTab: 'TAB_PAYMENT'
			}
		case "SET_STATE_ITEM":
			let item = state[payload.item] || {};
			return {
				...state,
				[payload.item]: {
					...item,
					...payload.part,
				}
			}

		case "SET_TRANSACTION":
			let transaction = state.transaction || {};
			return {
				...state,
				transaction: {
					...transaction,
					...payload,
				}
			}

		case "SET_TAX_PROFILE":
			let taxProfile = state.taxProfile || {};
			return {
				...state,
				taxProfile: {
					...taxProfile,
					...payload,
				}
			}

		case "SET_SAME_ACCOUNTS":
			return {
				...state,
				sameAccounts: payload,
			}

		case "SET_AGENT_SEARCH":
			let agentSearch = state.agentSearch || {};
			return {
				...state,
				agentSearch: {
					...agentSearch,
					...payload,
				}
			}

		case "SET_INVOICE":
			let invoice = state.invoice || {};
			return {
				...state,
				invoice: {
					...invoice,
					...payload,
				}
			}

		case "SET_AUTHENTICATION":
			let authenticateEntry = state.authenticateEntry || {};
			return {
				...state,
				authenticateEntry: {
					...authenticateEntry,
					...payload
				},
			}

		case "IN_LOADING":
		case "LOADING":
			return {
				...state,
				loading: true
			}
		case "LOADED":
			return {
				...state,
				loading: false
			}

		case "LOAD_FAILED":
			return {
				...state,
				message: payload,
				fakeLoading: false,
				loading: false,
			}

		default:
			return state
	}
}

export default reducer;